import Store from 'store/store'
import { Component } from 'utils/jsx'

import BoundingBox from 'abstractions/BoundingBox'

export default class Text extends Component {
  beforeRender ({
    value = '',
    x = 0, // unitless
    y = 0, // unitless
    font = Store.fonts.current[0],
    fontSize = 72 // unitless
  } = {}) {
    const path = font.getPath(value.trim(), x, y, fontSize)
    this.state.d = path.toPathData(Store.constants.get().DECIMALS)
    this.state.bbox = path.commands.length
      ? BoundingBox.fromOpentypePath(path)
      : BoundingBox.empty(x, y)
  }

  template (props) {
    return [
      <path d={this.state.d} class={props.class} fill={props.color} />,
      <line class='guide baseline no-export' x1='0%' y1={props.y} x2='100%' y2={props.y} />,
      this.state.bbox.vnode({ class: 'guide bbox no-export' })
    ]
  }
}



// WEBPACK FOOTER //
// ./src/components/paper/Text.js